let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let createStandardEventForm = require("../../createStandardEventForm");
let SlideOpenDown = require("../../../../widgets/SlideOpenDown");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");


module.exports = createStandardEventForm({
  eventToInitialValues(event) {
    return {
      evaluation_type: _.get(event, ["Evaluation", "evaluation_type"]) || 0,
      not_evaluated: _.get(event, ["Evaluation", "not_evaluated"], true),
      score: parseFloat(_.get(event, ["Evaluation", "score"])).toFixed(2) || 0,
      audience_size: _.get(event, ["audienceSize"]) || "",
      eval_link: _.get(event, ["Evaluation", "eval_link"]) || '',
      tracking_number: _.get(event, ["Evaluation", "tracking_number"]) || '',
      return_tracking_number: _.get(event, ["Evaluation", "return_tracking_number"]) || '',
      num_forms: _.get(event, ["Evaluation", "num_forms"]) || 0,
      sent_date: (!_.isEmpty(_.get(event, ["Evaluation", "sent_date"])) && (_.get(event, ["Evaluation", "sent_date"], "12/31/1969") !== "12/31/1969")) ? new Date(_.get(event, ["Evaluation", "sent_date"])) : "",
      received_date: (!_.isEmpty(_.get(event, ["Evaluation", "received_date"])) && (_.get(event, ["Evaluation", "sent_date"], "12/31/1969") !== "12/31/1969")) ? new Date(_.get(event, ["Evaluation", "received_date"])) : null,
      comments: _.get(event, ["Evaluation", "comments"]) || '',
      presenter_feedback: _.get(event, ["Evaluation", "presenter_feedback"]) || '',
      customer_feedback: _.get(event, ["Evaluation", "customer_feedback"]) || '',
      additional_feedback: _.get(event, ["Evaluation", "additional_feedback"]) || '',
      service_recovery: _.get(event, ["Evaluation", "service_recovery"]) || 0,
      service_recovery_amount: _.get(event, ["Evaluation", "service_recovery_amount"]) || 0,
      service_recovery_notes: _.get(event, ["Evaluation", "service_recovery_notes"]) || ''
    };
  },
  buildSchema({event, Displaylists, is_limited_speaker}, data) {
    let evaluation_types = _.get(Displaylists, ["sitelists", "evaluation_types"], []);

    let schema = {
      evaluation_type: {
        label: "Form Type",
        type: "newselect",
        placeholder: "-- select an evaluation form --",
        optgroups: ["Electronic Forms", "In Person Forms"],
        options: _.map(evaluation_types, function (evaluation_type) {
          return {
            optgroup: (_.get(evaluation_type, ["electronic"]) === 1 ? "Electronic Forms" : "In Person Forms"),
            value: _.get(evaluation_type, ["id"]),
            label: _.get(evaluation_type, ["name"]) + " - " +
                _.get(evaluation_type, ["description"])
          };
        }),
        validate: function(value) {
          if (!data.not_evaluated && _.isNaN(_.parseInt(value))) {
            return 'You must select an evaluation';
          }
          return true;
        },
        disabled: data.not_evaluated
      },
      not_evaluated: {
        label: "Not Evaluated",
        type: "checkbox"
      },
      score: {
        label: "Cumulative Score",
        type: "evaluation",
        className: "form-control",
        placeholder: "0.00",
        validate: function(value) {
          if (!data.not_evaluated && _.isNaN(parseFloat(value))) {
            return 'You must enter a score';
          }
          return true;
        },
        disabled: data.not_evaluated
      },
      audience_size: {
        label: "Audience Size",
        type: "text",
        placeholder: "0"
      },
      tracking_number: {
        label: "Tracking #",
        type: "text",
        placeholder: "123456789",
        disabled: data.not_evaluated
      },
      return_tracking_number: {
        label: "Return Tracking #",
        type: "text",
        placeholder: "123456789",
        disabled: data.not_evaluated
      },
      num_forms: {
        label: "Number of Evaluation Forms",
        type: "text",
        placeholder: "0",
        disabled: data.not_evaluated
      },
      sent_date: {
        label: "Date Sent",
        type: "date",
        read_only: data.not_evaluated,
        validate: function(value) {
          return true;
        }
      },
      received_date: {
        label: "Date Received",
        type: "date",
        read_only: data.not_evaluated,
        validate: function(value) {
          return true;
        }
      },
      comments: {
        label: "Summary of Evaluation Comments",
        type: "textarea",
        rows: 5,
        placeholder: "Enter summary of returned evaluation comments...",
        // disabled: data.not_evaluated
      },
      presenter_feedback: {
        label: "Presenter Feedback",
        type: "textarea",
        rows: 5,
        placeholder: "Enter summary of presenter feedback...",
        // disabled: data.not_evaluated
      },
      customer_feedback: {
        label: "Customer Feedback",
        type: "textarea",
        rows: 5,
        placeholder: "Enter summary of customer feedback...",
        // disabled: data.not_evaluated
      },
      additional_feedback: {
        label: "Additional Feedback & Next Steps",
        type: "textarea",
        rows: 5,
        placeholder: "Enter any additional feedback received and next steps from host and presenter...",
        // disabled: data.not_evaluated
      },
      service_recovery: {
        label: "Service Recovery",
        type: "newselect",
        options: [
          {value: 0, label: "Not needed"},
          {value: 1, label: "Needed"},
          {value: 2, label: "Complete"}
        ]
        // disabled: data.not_evaluated
      },
      service_recovery_amount: {
        label: "Amount",
        type: "text",
        placeholder: "0.00",
        // disabled: data.not_evaluated,
        validate: function(value) {
          // if (!data.not_evaluated && !_.contains([0], data.service_recovery) && _.isNaN(value)) {
          //   return 'You must enter an amount > 0 when service recovery is set';
          // }
          return true;
        }
      },
      service_recovery_notes: {
        label: "Recovery Option Description",
        type: "textarea",
        rows: 5,
        placeholder: "Enter notes regarding service recovery...",
        // disabled: data.not_evaluated,
        validate: function(value) {
          // if (!data.not_evaluated && !_.contains([0], data.service_recovery) && _.isEmpty(value)) {
          //   return 'You must enter comments when service recovery is set';
          // }
          return true;
        }
      },
    };

    if (_.get(_.find(evaluation_types, {"id": _.parseInt(data.evaluation_type)}), ["electronic"], 0) === 1) {
      schema.eval_link = {
        label: "Evaluation Form Link",
        type: "text",
        placeholder: "https://www.google.com",
        disabled: data.not_evaluated
      };
    }

    return schema;
  },
  onFormChanged(field_path, new_value, data, onChange) {
    if (field_path === 'return_tracking_number') {
      if (new_value !== null && !_.isDate(_.get(data, ["sent_date"], ""))) {
        onChange("sent_date", new Date());
      }
    }
    if (field_path === 'service_recovery_amount') {

    }
    return data;
  },
  writeInputDataToEvent(data, event) {
    event.audienceSize = _.get(data, ["audience_size"]) || 0;
    event.Evaluation = data;
  },
  renderFields() {
    let changes_made = this.Form_areChangesMade();

    return dd.div(null,
      dd.h2(null, "Evaluation"),
      ezHorizontalFields(this, [
        ["evaluation_type"],
        ["not_evaluated"],
        ["score"],
        ["audience_size"],
        ["eval_link"],
        ["tracking_number"],
        ["return_tracking_number"],
        ["num_forms"],
        ["sent_date"],
        ["received_date"]
      ]),
      SlideOpenDown({open: changes_made},
          HorizontalFieldSpot(null,
              FormButtons({onDiscard: this.__discardChanges})
          )
      ),
      dd.hr(),
      dd.h4({className: "section-head"}, "Notes"),
      ezHorizontalFields(this, [
        ["comments"],
        ["presenter_feedback"],
        ["customer_feedback"],
        ["additional_feedback"],
      ]),
      dd.hr(),
      dd.h4({className: "section-head"}, "Service Recovery"),
      ezHorizontalFields(this, [
        ["service_recovery"],
        ["service_recovery_amount"],
        ["service_recovery_notes"]
      ])
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/evals/EvalForm.js